import { IconButton, Tooltip } from '@mui/material';
import Iconify from 'src/components/iconify';

type Props = {
  onClick(): void;
  isActive: boolean;
  isEnabled: boolean;
  activeIcon: string;
  inactiveIcon: string;
  tooltip: string;
};

export const ActionIcon = ({
  onClick,
  isActive,
  activeIcon,
  inactiveIcon,
  isEnabled,
  tooltip,
}: Props) => {
  return (
    <Tooltip placement="top" arrow title={tooltip}>
      <span>
        <IconButton size="small" onClick={onClick}>
          {isActive ? (
            <Iconify
              icon={activeIcon}
              color={isEnabled ? 'success.main' : ''}
            />
          ) : (
            <Iconify icon={inactiveIcon} color="error.main" />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};
